<template>
  <LoadingSpinner :loading="isLoading" />
  <div class="container justify-content-center" id="productContainer">
    <div class="row justify-content-center">
      <div class="col-12">
        <div style="background:#fff;border-radius:10px;" class="p-5">
          <div v-if="!isLoading">
            <div class="row">
              <div class="col-3">
                <div v-if="productApiData != null" class=" d-flex align-items-center flex-column justify-content-center">
                  <div class="box-image" >
                    <img class="w-100" v-if="productApiData && productApiData.images" :src="'https://cdn.awsli.com.br/500x500/' + productApiData.images[0].caminho"/>
                  </div>
                  <div class="mt-3">
                    <b>{{ productApiData.nome }}</b>
                  </div>
                </div>
              </div>
              <div class="col-4 generalRating">                
                <strong>{{ generalRating || 0 }}</strong>              
                <div class="rating justify-content-center">
                  <i v-for="rating in 5" :key="rating" :class="
                      {
                        'fa fa-star': rating <= (generalRating || 0),
                        'fa fa-star-o': rating > (generalRating || 0)
                      }
                    "></i>
                </div>
                <small><b>baseado em</b> {{ testimonialsTotals }} avaliações</small>
              </div>
              <div class="col-5 d-flex flex-column-reverse justify-content-center">
                <div class="row my-2" v-for="(reaction, index) of reactions" :key="index">
                  <div class="col-3">{{ reaction }}</div>
                  <div class="col-8">                  
                    <span class="chart">
                      <span v-if="scores[index] > 0" class="fuel" :style="{width: ((scores[index] / testimonialsTotals)*100) + '%'}"></span>
                    </span>
                  </div>
                  <div class="col-1">
                    <small>{{ scores[index] }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="divider my-5"></div>
            <div class="row filter-date mb-5">
              <div class="col">
                <button :class="'btn ' + (dateFilter == 30 ? 'active' : '')" @click="setDateFilter(30)" type="button">30 dias</button>
              </div>
              <div class="col">
                <button :class="'btn ' + (dateFilter == 60 ? 'active' : '')" @click="setDateFilter(60)" type="button">60 dias</button>
              </div>
              <div class="col">
                <button :class="'btn ' + (dateFilter == 90 ? 'active' : '')" @click="setDateFilter(90)" type="button">90 dias</button>
              </div>
              <div class="col">
                <button :class="'btn ' + (dateFilter == 180 ? 'active' : '')" @click="setDateFilter(180)" type="button">6 meses</button>
              </div>
              <div class="col">
                <button :class="'btn ' + (dateFilter == 360 ? 'active' : '')" @click="setDateFilter(360)" type="button">1 ano</button>
              </div>
              <div class="col">
                <button :class="'btn ' + (dateFilter == 0 ? 'active' : '')" @click="setDateFilter(0)" type="button">Geral</button>
              </div>
            </div>
            
            <div class="row testimonials" v-for="item in testimonials" :key="item.id">
              <div class="col-3 col-md-2 rating_ text-center">
                <b>{{ item.attributes.rating }}</b>
                <div class="rating justify-content-center">
                  <i v-for="rating in 5" :key="rating" :class="
                      {
                        'fa fa-star': rating <= (item.attributes.rating || 0),
                        'fa fa-star-o': rating > (item.attributes.rating || 0)
                      }
                    "></i>
                </div>
              </div>
              <div class="col-md-10 col-9">
                <p>{{ item.attributes.content }}</p>
                <small><strong>{{ item.attributes.order.data.attributes.client_name.split(' ')[0] }}</strong> em {{ formatDate(item.attributes.publishedAt) }}</small>
              </div>
              <div class="col-12">
                <div class="divider my-4"></div>
              </div>
            </div>

            <div class="row pagination mt-4 justify-content-center align-items-center">
              <div class="col-auto" v-for="item of pagination.pageCount" :key="item">
                <button type="button"
                @click="setPage(item)"
                :class="'btn ' + (item == page ? 'active' : '')">
                  {{  item  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style scoped>
.generalRating{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.generalRating small{margin: 1rem 0 0rem 0;}
.generalRating i{font-size: 30px;}
.generalRating strong{font-size: 120px;margin-top: -30px;}
.chart{
  border: 1px solid #f2f2f2;
  width:100%;
  display:flex;
  height: 20px;
  border-radius: 10px;
  background: #f8f8f8;

}
.chart .fuel{
  background: var(--violet);
  border-radius: 10px;
}
.pagination button{
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
  border: 1px solid;
}
.pagination button.active{
  background: var(--violet);
}
.testimonials strong{text-transform: capitalize;}
.rating_ b{
  font-size:28px
}
.testimonials .rating{
  display: flex;
  font-size: 12px;

}
.filter-date button:not(.active):hover{
  background: var(--black);
  color: #fff;
}
.filter-date button.active{
  background: var(--green);
  font-weight:bold

}
.filter-date button{
  border: 1px solid var(--black);
  width: 100%;
}
.divider{border-bottom: 1px solid #d9d9d9;}
.h1{
  text-transform: uppercase;
}
.h1 small{
  font-size: 20px;
}
.h1 b{display: block;font-size: 44px;}
.btn.btn-big i{margin-top:4px}
.btn.btn-big{
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem 2rem;
  background: var(--black);
  color:#fff;
  text-transform: uppercase;

}
.box-image{border:1px solid #d9d9d9;border-radius:10px;overflow:hidden}
.product_item{border-bottom: 1px solid #d9d9d9;}
  .fa.fa-star,
  .fa.fa-star-o{
    color: var(--green);
  }
  .rating{
    display:flex;
    gap:5px;
    align-items: center;
  }
  .rating span{
    font-weight: bold;
    font-size: 12px;
    margin-left: .5rem;
    color: var(--black);
    background:var(--violet);
    border-radius:10px;
    padding:3px 10px
  }
  .rating_btn{
    padding: 0;
    border: 0;
    background: transparent;
    font-size:24px;
  }
</style>

<script>
import axios from 'axios';
// const FormData = require('formdata-node');
// const fetch = require('node-fetch');


// URL da API que você deseja acessar
const apiUrl = 'https://cms-cdsg.up.railway.app/api/';
// const apiUrl = 'http://localhost:1337/api/';

// Configuração do cabeçalho de autorização
const config = {
  headers: {
//    Authorization: `Bearer ${token}`,
  },
};
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  components: {
    LoadingSpinner
  },
  name: 'ProductRating',
  props:["sku"],
  data() {
    return {
      order:{},
      items: [],
      hash:null,
      ratings:[1,2,3,4,5],
      reactions:["Péssimo","Ruim", "Bom", "Ótimo", "Excelente"],
      store:{
        rating:0,
        content:""
      },
      generalRating:0,
      scores : [0,0,0,0,0],
      errForm : [],
      testimonials : [],
      isLoading:true,
      dateFilter : 30,
      page:1,
      pagination:[],
      testimonialsTotals : 0,
      productApiData : null
    };
  },
  async mounted() {
    await this.fetchItemsFromApi(); // Aguarde a conclusão da solicitação
  },
  created(){
    console.log(this.hash)
    
   
  },  
  methods: {
    async fetchProductInfo(){
      // const response = await axios.get(`https://api.awsli.com.br/v3/products/${id_}`, {
      //   headers: {
      //     "x-store-id": `2613030`,
      //   },
      // });
      // return response.data.data
      const response = await axios.get(apiUrl + `webhooks/produto-loja-integrada?sku=${this.sku}`, config);
          console.log(response.data)
         
      return response.data
    },
    setDateFilter(num){
      this.dateFilter = num

      this.fetchItemsFromApi()
    },
    setPage(num){
      this.page = num

      this.fetchItemsFromApi()
    },
    formatDate(originalDateStr){
      const originalDate = new Date(originalDateStr);
      const formattedMonth = (originalDate.getMonth() + 1).toString().padStart(2, '0');
      const formattedDay = originalDate.getDate().toString().padStart(2, '0');
      const formattedYear = originalDate.getFullYear();
      const formattedDate = `${formattedDay}/${formattedMonth}/${formattedYear}`;
      return formattedDate
    },
    async countTestimonials(){
      this.testimonialsTotals = 0
      let rating_ = 0
      for(let rating = 1; rating <=5; rating++){  
        console.log(rating)      
        let params = "";
        if(this.dateFilter > 0){
          let cDate = new Date();
          let nDate = new Date(cDate)
          nDate.setDate(cDate.getDate() - this.dateFilter)
          params = params + `&filters[publishedAt][$gte]=${this.formatDateToISOString(nDate)}`
        }

        
        params = params + `&filters[rating]=${rating}`
        
        try {
          const response = await axios.get(apiUrl + `testimonials?filters[type][$eq]=product&filters[product_sku][$eq]=${this.sku}${params}`, config);
          console.log(response.data.meta.total)
          this.scores[rating-1] = response.data.meta.pagination.total
          this.testimonialsTotals += this.scores[rating-1]
          rating_ += this.scores[rating-1] * rating
        } catch (error) {
          console.error('Erro ao buscar itens:', error);
        }  
        
        this.generalRating = rating_ / this.testimonialsTotals
      }
      
      console.log('scores',this.scores)      
    },
    formatDateToISOString(date) {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      const seconds = String(date.getUTCSeconds()).padStart(2, '0');
      const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    },
    async fetchItemsFromApi() {
      this.isLoading = true
      setTimeout(function () {parent.postMessage(document.getElementById('productContainer').height, "*");}, 1000);
      
      let params = "";
      if(this.dateFilter > 0){
        let cDate = new Date();
        let nDate = new Date(cDate)
        nDate.setDate(cDate.getDate() - this.dateFilter)
        params = params + `&filters[publishedAt][$gte]=${this.formatDateToISOString(nDate)}`
      }

      if(this.dateFilter <= 90 && this.dateFilter != 0){
        params = params + `&sort[0]=publishedAt:desc`        
      }else{
        params = params + `&sort[0]=publishedAt:asc`        
      }

      params = params + `&pagination[page]=${this.page}`

      try {
        const response = await axios.get(apiUrl + `testimonials/?filters[type][$eq]=product&filters[product_sku][$eq]=${this.sku}&populate=order${params}&populate=deep&pagination[pageSize]=25`, config);
        console.log(response)
        this.testimonials = [...response.data.data]
        this.pagination = response.data.meta.pagination
        
        if(this.productApiData == null){
          let q = this.testimonials[0].attributes.order.data.attributes.products.find(el => el.sku == this.sku)
          if(q){
            this.productApiData = await this.fetchProductInfo(q.produto_id)
          }
        }
        

      } catch (error) {
        console.error('Erro ao buscar itens:', error);
      }

      await this.countTestimonials()

      this.isLoading = false
      setTimeout(function () {parent.postMessage(document.getElementById('productContainer').height, "*");}, 1000);
      
      
    },
  },
};
</script>






